/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Classbookingfilteraspect4Inputs */



/**

* @param {_Class_Classbookingfilteraspect4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_classbookingfilteraspect4 = /** @type {((inputs?: _Class_Classbookingfilteraspect4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Classbookingfilteraspect4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("besitzt")
});
export { _class_classbookingfilteraspect4 as "_class_ClassBookingFilterAspect" }